<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Matching Information
          </div>
        </template>
      </es-header>
    </div>
    <es-exception
      v-if="Object.keys(personMatchingInformation).length === 0"
      style="padding: 3rem; margin: 0"
      exceptionMessage="No Matching Information found."
    />
    <div v-else class="content" style="padding: 1rem 0">
      <es-form>
        <template #es-form>
          <div class="row">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Last Match Date
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ personMatchingInformation.lastUpdateDate | formatDateMMDDYYYY }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Match Score
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ matchScore }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Match Decision
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ matchDecision }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Match Note
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ matchNote }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Record Status
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div
                    class="control"
                    :class="{ 'center': !recordStatusInfo }"
                  >
                    <es-loader v-if="!recordStatusInfo" size="2x"/>
                    <span v-else>
                      {{ recordStatusInfo.description }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </es-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import DateUtils from '@/mixins/DateUtils';
import FieldLabels from '@/mixins/FieldLabels';
import StateIdUtils from '@/mixins/StateIdUtils';

export default {
  mixins: [
    DateUtils,
    FieldLabels,
    StateIdUtils,
  ],
  components: {
    EsException,
    EsForm,
    EsHeader,
    EsLoader,
  },
  props: {
    personMatchingInformation: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      recordStatus: {},
    };
  },
  created() {
    this.loadPidTransactionStatuses();
  },
  computed: {
    ...mapGetters('lookups', [
      'pidTransactionStatuses',
    ]),
    recordStatusInfo() {
      return this.pidTransactionStatuses.map(r => r.list).flat()
        .find(x => x.id === this.personMatchingInformation.transStatus);
    },
    matchDecision() {
      if (this.personMatchingInformation.pidMatchTransDetail) {
        if (this.personMatchingInformation.pidMatchTransDetail.response.matchDecision === 'MATCHED') {
          return `Match (${this.formatStateID(this.personMatchingInformation.pidMatchTransDetail.response.matchedPersonAbbreviated.id)})`;
        }
        if (this.personMatchingInformation.pidMatchTransDetail.response.matchDecision === 'NEAR_MATCHED') {
          return `Near Match (${this.formatStateID(this.personMatchingInformation.pidMatchTransDetail.response.potentialMatches[0].id)})`;
        }
        if (this.personMatchingInformation.pidMatchTransDetail.response.matchDecision === 'NO_MATCHES') {
          return `No Match (${this.formatStateID(this.personMatchingInformation.pidMatchTransDetail.response.newPidIdCreated)})`;
        }
      }
      return null;
    },
    matchNote() {
      if (this.personMatchingInformation.pidMatchTransId) {
        return this.personMatchingInformation.pidMatchTransId.note;
      }
      return null;
    },
    matchScore() {
      if (this.personMatchingInformation.pidMatchTransDetail) {
        if (this.personMatchingInformation.pidMatchTransDetail.response.matchDecision === 'MATCHED'
          || this.personMatchingInformation.pidMatchTransDetail.response.matchDecision === 'NEAR_MATCHED') {
          return this.personMatchingInformation.pidMatchTransId.matchPercent;
        }
        if (this.personMatchingInformation.pidMatchTransDetail.response.matchDecision === 'NO_MATCHES') {
          return '--';
        }
      }
      return null;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidTransactionStatuses',
    ]),
  },
};
</script>

<style lang="sass" scoped>
.center
  text-align: center
</style>
